import {
  BEGIN_EDITING_USER,
  SAVE_USER,
  SAVE_USER_SUCCESS,
  SAVE_USER_ERROR,
  END_EDITING_USER,
  INVITE_USER,
  INVITE_USER_SUCCESS,
  INVITE_USER_ERROR,
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  editing: false,
  user: null,
  syncingWithServer: false,
  userIsNew: false,
  error: null,
  message: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case BEGIN_EDITING_USER:
      return {
        editing: true,
        user: action.payload,
        userIsNew: (action.payload && action.payload._id) ? false : true,
        error: null,
        message: null,
      }
    case SAVE_USER:
      return {
        ...state,
        user: action.payload,//to update user locally
        syncingWithServer: true,
        error: null,
        message: null,
      }
    case SAVE_USER_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        syncingWithServer: false,
        userIsNew: false,
        error: null,
        message: action.payload.message,
      }
    case SAVE_USER_ERROR:
      return {
        ...state,
        syncingWithServer: false,
        error: action.payload,
        message: null,
      }
    case END_EDITING_USER:
      return DEFAULT_STATE;
    case INVITE_USER:
      return {
        ...state,
        error: null,
        mesage: null,
        syncingWithServer: true,
      }
    case INVITE_USER_SUCCESS:
      return {
        ...state,
        syncingWithServer: false,
        message: action.payload,
        error: null,
      }
    case INVITE_USER_ERROR:
      return {
        ...state,
        syncingWithServer: false,
        error: action.payload,
        message: null,
      }

  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/editingUserReducer.js